import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Linkedin, Twitter, Facebook } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://cdn.builder.io/api/v1/image/assets%2Fa4df95d82bc041cbb664cd3ad9b3dd03%2F8c30a2ca26c0413982746529797f4c1b?format=webp&width=800&height=1200"
                alt="Arrow Construction"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Building tomorrow's spaces with precision, quality, and excellence.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition-colors">
                <Linkedin size={18} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition-colors">
                <Twitter size={18} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition-colors">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: "Home", href: "/" },
                { label: "About", href: "/about" },
                { label: "Projects", href: "/projects" },
                { label: "Services", href: "/services" },
              ].map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-gray-300 hover:text-secondary transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-3">
              <li className="flex gap-3 text-sm text-gray-300">
                <Phone size={16} className="flex-shrink-0 mt-0.5" />
                <a href="tel:+918976004522" className="hover:text-secondary transition-colors">+91 89760 04522</a>
              </li>
              <li className="flex gap-3 text-sm text-gray-300">
                <Mail size={16} className="flex-shrink-0 mt-0.5" />
                <a href="mailto:info@arrowconstruction.in" className="hover:text-secondary transition-colors">info@arrowconstruction.in</a>
              </li>
              <li className="flex gap-3 text-sm text-gray-300">
                <MapPin size={16} className="flex-shrink-0 mt-0.5" />
                <span>204-Herumb Bldg, M. Phule Road, Mulund (E), Mumbai-81</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Newsletter</h4>
            <p className="text-gray-300 text-sm mb-4">Subscribe for project updates and industry insights.</p>
            <form className="flex flex-col gap-2" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Your email"
                className="px-3 py-2 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 text-sm focus:outline-none focus:border-secondary"
              />
              <button type="submit" className="px-4 py-2 bg-secondary text-primary font-semibold rounded-lg hover:opacity-90 transition-opacity text-sm">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm">© {currentYear} Arrow Construction. All rights reserved.</p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
